<template>
  <div :class="this.fieldClass()">
    <label v-if="labelText" class="field-label" :htmlFor="name">
      {{ labelText }}
    </label>
    <input
      :disabled="disabled"
      :ref="reference"
      tabindex="0"
      :id="name"
      class="field-input"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :autocomplete="autoComplete"
      :maxLength="maxLength"
      @focus="onFocus"
      @blur="onBlur"
      @input="onChange"
    />
    <label v-if="showValidation" class="field-status"
      ><CustomIcon name="warning" />{{ fieldValidator.message }}</label
    >
  </div>
</template>
<script>
import { ValidationData, createValidationDataObject } from "@/utils";
import CustomIcon from "./CustomIcon.vue";

export default {
  name: "field-component",
  components: { CustomIcon },
  props: {
    onChange: {
      type: Function,
      default(event) {
        return event;
      },
    },
    onBlur: {
      type: Function,
      default(event) {
        return event;
      },
    },
    onFocus: {
      type: Function,
      default(event) {
        return event;
      },
    },
    validator: {
      type: Function,
      default() {
        return ValidationData;
      },
    },
    placeholder: String,
    type: String,
    name: String,
    value: String,
    labelText: String,
    touched: Boolean,
    maxLength: Number,
    autoComplete: Boolean,
    reference: String,
    disabled: Boolean,
  },
  methods: {
    fieldClass() {
      const { valid } = this.fieldValidator;
      let className = "field";
      if (this.touched && !valid) {
        className += " " + "is-invalid";
      }
      return className;
    },
  },
  computed: {
    fieldValidator() {
      const { valid, message } = this.validator
        ? this.validator(this.value)
        : createValidationDataObject();
      return { valid, message };
    },
    showValidation() {
      const { valid } = this.fieldValidator;
      return !valid && this.touched;
    },
  },
};
</script>
